import { useMutation } from "@apollo/client";
import { CheckIcon } from "@heroicons/react/outline";
import { MenuItem } from "@szhsin/react-menu";

import getMeetingQuery from "@apps/meeting-new/graphql/get-meeting-query";
import setMeetingTopicCarryForwardMutation from "@apps/meeting-new/graphql/set-meeting-topic-carry-forward-mutation";
import { classNames } from "@helpers/css";

const CarryForwardMenuItem = ({ topic, meeting, occurrence }: any) => {
  const [setCarryForward, { loading }] = useMutation(
    setMeetingTopicCarryForwardMutation,
  );

  return (
    <MenuItem
      className="text-sm"
      disabled={!occurrence.canChangePin || loading}
      onClick={() =>
        setCarryForward({
          variables: {
            topicId: topic.id,
            meetingId: meeting.id,
            carryForward: !occurrence.carryForward,
          },
          refetchQueries: [
            { query: getMeetingQuery, variables: { meetingId: meeting.id } },
          ],
          awaitRefetchQueries: true,
        })
      }
    >
      <CheckIcon
        className={classNames(
          "mr-3 h-5 w-5 text-gray-500",
          !occurrence.carryForward && "invisible",
        )}
      />
      Carry into future meetings
    </MenuItem>
  );
};

export default CarryForwardMenuItem;
